import React from 'react';
import './style.scss';

const Switch = ({ checked, label, onChange }) => (
  <label>
    <div className="switchContainer">
      <input type="checkbox" className="switch" checked={checked} onChange={onChange} />
      <div>
        <div />
      </div>
      <p>{label}</p>
    </div>
  </label>
);

export { Switch };



// WEBPACK FOOTER //
// ./src/view/common/Switch/index.jsx